const toolsManageRouter = {
  path: "/tools",
  name: "操作",
  meta: { title: "操作", icon: "el-icon-s-tools" },
  redirect: "/tools/clearRedis",
  component: () => import("../../views/toolsManage/index.vue"),
  children: [
    {
      path: "/tools/clearRedis",
      name: "清缓存",
      meta: { title: "清缓存" },
      component: () => import("../../views/toolsManage/clearRedis/index.vue")
    },
    {
      path: "/tools/authManage",
      name: "账号管理",
      meta: { title: "账号管理" },
      component: () => import("../../views/toolsManage/authManage/index.vue")
    },
    {
      path: "/tools/checkResource",
      name: "资源查重",
      meta: { title: "资源查重" },
      redirect: "/tools/checkResource/list",
      component: () => import("../../views/toolsManage/checkResource/index.vue"),
      children: [
        {
          path: "/tools/checkResource/list",
          name: "资源列表",
          hidden: true,
          meta: { activePath: "/tools/checkResource", title: "资源列表" },
          component: () =>
            import("../../views/toolsManage/checkResource/list.vue")
        },
        {
          path: "/tools/checkResource/create",
          name: "新建资源",
          hidden: true,
          meta: { activePath: "/tools/checkResource", title: "新建资源" },
          component: () =>
            import("../../views/toolsManage/checkResource/createOrEdit")
        },
        {
          path: "/tools/checkResource/info/:id",
          name: "查看资源",
          hidden: true,
          meta: { activePath: "/tools/checkResource", title: "查看资源" },
          component: () =>
            import("../../views/toolsManage/checkResource/info")
        }
      ]
    },
    {
      path: "/tools/aiRoleReview",
      name: "Ai角色审核",
      meta: { title: "Ai角色审核" },
      redirect: "/tools/aiRoleReview/list",
      component: () =>
        import("../../views/toolsManage/aiRoleReviewManage/index.vue"),
      children: [
        {
          path: "/tools/aiRoleReview/list",
          name: "资源列表",
          hidden: true,
          meta: { activePath: "/tools/aiRoleReview", title: "资源列表" },
          component: () =>
            import("../../views/toolsManage/aiRoleReviewManage/list.vue")
        },
        {
          path: "/tools/aiRoleReview/info/:id",
          name: "查看资源",
          hidden: true,
          meta: { activePath: "/tools/aiRoleReview", title: "查看资源" },
          component: () =>
            import("../../views/toolsManage/aiRoleReviewManage/info.vue")
        }
      ]
    },
    {
      path: "/tools/aiRoleMemoryReview",
      name: "Ai角色聊天审核",
      meta: { title: "Ai角色聊天审核" },
      component: () =>
        import("../../views/toolsManage/aiRoleMemoryReviewManage/index.vue")
    },
    {
      path: "/tools/uploadFile",
      name: "文件上传",
      meta: { title: "文件上传", menuAliases: ["图片上传"] },
      component: () =>
        import("../../views/toolsManage/uploadFileManage/index.vue")
    }
  ]
};
export default toolsManageRouter;
